import { render, staticRenderFns } from "./Spxkz.vue?vue&type=template&id=f7963be6&scoped=true&"
import script from "./Spxkz.vue?vue&type=script&lang=js&"
export * from "./Spxkz.vue?vue&type=script&lang=js&"
import style0 from "./Spxkz.vue?vue&type=style&index=0&id=f7963be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7963be6",
  null
  
)

export default component.exports